import { data } from '../../svg/Phase/data';
import { makeIcon } from '../makeIcon';

export const Phase = makeIcon(data, 'phase', 'Phase');

export default Phase;
